module.exports = __webpack_public_path__ + "img/logo-adeg-full-new.0870870c.png";